import { createUseStyles } from 'react-jss'
import { TextAlignment, ThemeDefinition } from '../../../data/types'
import ContentLimits from '../../../styles/ContentLimits'
import MediaQueries from '../../../styles/MediaQueries'
import { neonLime } from '../../../styles/colors'

export interface ParagraphStyleProps {
  textAlignment: TextAlignment
}

const useStyles = createUseStyles<any, ParagraphStyleProps, ThemeDefinition>(
  ({
    paragraphContainer: {
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center'
    },

    paragraph: {
      flex: 1,
      display: 'flex',
      flexDirection: 'column',
      boxSizing: 'border-box',
      gap: '8px',
      textAlign: ({ textAlignment }) => textAlignment.toLowerCase(),
      alignItems: ({ textAlignment }: ParagraphStyleProps) => {
        switch (textAlignment) {
          case TextAlignment.Left:
            return 'flex-start'
          case TextAlignment.Center:
            return 'center'
          case TextAlignment.Right:
            return 'flex-end'
          default:
            return 'flex-start'
        }
      },
      '@global': {
        a: {
          color: neonLime
        },

        u: {
          color: neonLime,
          textDecoration: 'none'
        },

        b: {
          fontWeight: 600
        },

        p: {
          fontFamily: 'GTWalsheim',
          fontWeight: 400,
          fontSize: '14px',
          lineHeight: '100%',
          margin: 0
        },
        p2: {
          fontFamily: 'GothamRounded',
          fontWeight: 400,
          fontSize: '8px',
          lineHeight: '12px',
          marginBottom: '17px',
          margin: 0
        },
        h1: {
          fontFamily: 'GTWalsheim',
          fontWeight: 700,
          fontSize: '32px',
          lineHeight: '100%',
          margin: 0
        },
        h2: {
          fontFamily: 'GTWalsheim',
          fontWeight: 700,
          fontSize: '24px',
          lineHeight: '100%',
          margin: 0
        },
        h4: {
          fontFamily: 'GothamRounded',
          fontWeight: 500,
          fontSize: '14px',
          lineHeight: '19px',
          margin: 0
        }
      }
    },

    button: {
      display: 'flex'
    },

    [MediaQueries.Tablet]: {
      paragraph: {
        maxWidth: ContentLimits[MediaQueries.Tablet]
      },

      button: {
        display: 'none'
      }
    },
    [MediaQueries.LaptopSmall]: {
      paragraph: {
        maxWidth: ContentLimits[MediaQueries.LaptopSmall]
      }
    },
    [MediaQueries.LaptopLarge]: {
      paragraph: {
        maxWidth: ContentLimits[MediaQueries.LaptopLarge],
        '@global': {
          p2: {
            fontSize: '10px',
            lineHeight: '12px',
            marginBottom: '21px'
          }
        }
      }
    }
  })
)

export default useStyles
